<template>
  <div>
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div
        class="section-title"
      >{{ $tc('add') }} {{ $tc('distributor', 1) }} {{ $t('share') }} {{ $tc('type', 1) }}</div>
      <router-link
        class="btn-blue"
        to="distributor-share-type"
      >{{ $tc('distributor', 1) }} {{ $t('share') }} {{ $tc('type', 1) }} {{ $tc('list',2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <div class="col-6 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="distributorShareType.dst_label"
                  placeholder="."
                  type="text"
                  name="sharelabel"
                  id="sharelabel"
                  v-validate="'required|alpha_spaces'"
                />
                <label>{{ $t('sharelabel') }}</label>
              </div>
              <Tooltip :title="$t('sharelabel_tooltip')" />
            </div>
            <p
              v-if="submitted && errors.has('sharelabel')"
              class="error_message"
            >{{ errors.first('sharelabel') }}</p>
          </div>

          <div class="col-6 mb-4 align-self-center">
            <div class="d-flex">
              <p class="mb-0 mr-3">{{ $t('fixedValueToTheatre') }}</p>
              <b-form-checkbox
                unchecked-value="N"
                value="Y"
                v-model="distributorShareType.dst_fixed_value_to_theatre"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>

          <div class="col-6 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="distributorShareType.dst_percentage_of.length > 0 ? 'shift-up' : '' "
                >{{ $t('percentgeOf') }}</label>
                <b-dropdown
                  :text="distributorShareType.dst_percentage_of"
                  variant="dropdown-curve"
                  class="w-100"
                  name="selectpercentage"
                  id="selectpercentage"
                >
                  <!-- v-validate="'required'" -->
                  <b-dropdown-item v-on:click="onSelectPercentage($event,'Net Amount')">Net Amount</b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="onSelectPercentage($event,'Gross Amount')"
                  >Gross Amount</b-dropdown-item>
                </b-dropdown>
              </div>
              <Tooltip :title="$t('percentageof_tooltip')" />
            </div>
            <p
              v-if="submitted && distributorShareType.dst_percentage_of.length === 0"
              class="error_message"
            >{{ messagepercentage }}</p>
          </div>

          <div class="col-6 mb-4 align-self-center">
            <div class="d-flex">
              <p class="mb-0 mr-3">{{ $t('isPercentageValue') }}</p>
              <b-form-checkbox
                v-model="distributorShareType.dst_is_percentage"
                unchecked-value="N"
                value="Y"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>

          <div class="col-6 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="distributorShareType.dst_duration.length > 0 ? 'shift-up' : '' "
                >{{ $t('duration') }}</label>
                <b-dropdown
                  :text="distributorShareType.dst_duration"
                  variant="dropdown-curve"
                  class="w-100"
                  name="selectduration"
                  id="selectduration"
                >
                  <!-- v-validate="'required'" -->
                  <b-dropdown-item v-on:click="onSelectDuration($event,'Weekly')">Weekly</b-dropdown-item>
                  <b-dropdown-item v-on:click="onSelectDuration($event,'Daily')">Daily</b-dropdown-item>
                </b-dropdown>
              </div>
              <Tooltip :title="$t('duration_tooltip')" />
            </div>
            <p
              v-if="submitted && distributorShareType.dst_duration.length === 0"
              class="error_message"
            >{{ messageduration }}</p>
          </div>

          <div class="col-6 mb-4 align-self-center">
            <div class="d-flex">
              <p class="mb-0 mr-3">{{ $t('active') }}</p>
              <b-form-checkbox
                v-model="distributorShareType.dst_is_active"
                unchecked-value="N"
                value="Y"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>

          <div class="col-6 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="distributorShareType.dst_share_type_description"
                  type="text"
                  placeholder="."
                  name="dst_share_type_description"
                  id="dst_share_type_description"
                  v-validate="'required'"
                />
                <label>{{ $t('EnterMessage') }}</label>
              </div>
              <Tooltip :title="$t('dst_share_type_description_tooltip')" />
            </div>
            <p
              v-if="submitted && errors.has('dst_share_type_description')"
              class="error_message"
            >{{ errors.first('dst_share_type_description') }} sss</p>
          </div>

          <div class="col-12 text-center">
            <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit"
              class="btn-blue"
            >{{ $t('save') }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import DistributorService from "@/services/DistributorService";

export default {
  data() {
    return {
      btenable: false,
      messagepercentage: "Please Select Percentage Of.",
      messageduration: "Please Select Duration.",
      submitted: false,
      // Saif
      distributorShareType: {
        dst_label: "",
        dst_fixed_value_to_theatre: "Y",
        dst_percentage_of: "",
        dst_is_percentage: "Y",
        dst_duration: "",
        dst_is_active: "Y",
        dst_share_type_description: ""
      },

      // Saif
      checked: "y",
      percentageOf: "",
      shareDuration: ""
    };
  },
  beforeMount() {},
  mounted() {},
  methods: {
    // Saif

    onSelectPercentage: function(event, params) {
      this.distributorShareType.dst_percentage_of = params;
    },
    onSelectDuration: function(event, params) {
      this.distributorShareType.dst_duration = params;
    },
    onFinalSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;
          DistributorService.AddDistributorShareType(this.distributorShareType)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$router.push({
                  path: "/distributor/distributor-share-type"
                });
              } else {
                this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
              }
            })
            .catch(this._CatchError); //message
        }
      });
    }
    // Saif
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorShareTypeComponents/addDistributorShareType.vue